var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoSelfid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5074_3787)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_5074_3787",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.75H5.97826V6.22826H0.5V0.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.75V-1.25H-1.5V0.75H0.5ZM0.5 0.75V2.75H5.97826V0.75V-1.25H0.5V0.75ZM0.5 6.22826H2.5V0.75H0.5H-1.5V6.22826H0.5Z",
    fill: "white",
    mask: "url(#path-2-inside-1_5074_3787)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2_5074_3787",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 30.75L0.5 25.2717H5.97826V30.75H0.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 30.75H-1.5V32.75H0.5L0.5 30.75ZM0.5 30.75H2.5L2.5 25.2717H0.5H-1.5L-1.5 30.75H0.5ZM5.97826 30.75V28.75H0.5L0.5 30.75L0.5 32.75H5.97826V30.75Z",
    fill: "white",
    mask: "url(#path-4-inside-2_5074_3787)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-3_5074_3787",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5 30.75H25.0217V25.2717H30.5V30.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 30.75V32.75H32.5V30.75H30.5ZM30.5 30.75V28.75H25.0217V30.75V32.75H30.5V30.75ZM30.5 25.2717H28.5V30.75H30.5H32.5V25.2717H30.5Z",
    fill: "white",
    mask: "url(#path-6-inside-3_5074_3787)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-4_5074_3787",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5 0.75V6.22826L25.0217 6.22826V0.75L30.5 0.75Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 0.75L32.5 0.75V-1.25L30.5 -1.25V0.75ZM30.5 0.75L28.5 0.75V6.22826H30.5H32.5V0.75L30.5 0.75ZM25.0217 0.75V2.75L30.5 2.75V0.75V-1.25L25.0217 -1.25V0.75Z",
    fill: "white",
    mask: "url(#path-8-inside-4_5074_3787)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 13.25,
    r: 4.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 23.25C20.5 22.0565 20.0259 20.9119 19.182 20.068C18.3381 19.2241 17.1935 18.75 16 18.75C14.8065 18.75 13.6619 19.2241 12.818 20.068C11.9741 20.9119 11.5 22.0565 11.5 23.25L16 23.25H20.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5074_3787"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 1,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSelfid);
export default __webpack_public_path__ + "static/media/logo-selfid.8f96aacbc903ccbf3a40327c1c7d55ab.svg";
export { ForwardRef as ReactComponent };